// Mais recentes primeiro: pela data do prontuário ('yyyy-MM-dd') e, no mesmo dia, pelo código maior.
// A mesma ordem da aba Prontuário do cadastro do paciente e do prontuário mais recente do Dashboard
export const newestFirst = (a, b) => b.data_cadastro.localeCompare(a.data_cadastro) || (b.codigo - a.codigo);

// Último prontuário cadastrado (o primeiro da aba Prontuário do paciente); null quando a lista está vazia
export const latestProntuario = (prontuarios) => (prontuarios?.length ? [...prontuarios].sort(newestFirst)[0] : null);
